import type {
    EditorReactComponent,
    Style as ManifestStyle,
    Behaviors as ManifestBehaviors,
    EditorElement as ManifestEditorElement,
    Elements as ManifestElements,
    ElementItem as ManifestElementItem,
    Data as ManifestData,
    Presets as ManifestPresets,
    DataOverrides as ManifestDataOverrides,
    StyleOverrides as ManifestStyleOverrides,
    ElementsDefaults as ManifestElementDefaults
} from '@wix/component-protocol/schema'

export namespace Builder {
    export type Manifest = EditorReactComponent
    export type ResolvedManifest = EditorReactComponent
    export type ResolvedEditorElement = ManifestEditorElement
    export type Style = ManifestStyle
    export type StyleItem = NonNullable<ManifestStyle>[string]
    export type StyleType =
        | NonNullable<ManifestStyle>[string]['cssVariableType']
        | NonNullable<ManifestStyle>[string]['cssPropertyType']
    export type Behaviors = ManifestBehaviors
    export type Elements = ManifestElements
    export type ElementItem = ManifestElementItem
    export type Data = ManifestData
    export type DataType = NonNullable<ManifestData>[string]['dataType']
    export type Presets = NonNullable<ManifestPresets>
    export type PresetItem = NonNullable<Presets>[string]
    export type DataItem = NonNullable<Data>[string]
    export type DataItemOverrides = NonNullable<ManifestDataOverrides>
    export type ElementsDefaults = NonNullable<ManifestElementDefaults>
    export type StyleOverrides = NonNullable<ManifestStyleOverrides>
    export interface ResolvedElements {
        [key: string]: ManifestEditorElement & {
            elements?: ResolvedElements
        }
    }
}
interface AppData {
    componentId: string
    appDefinitionId: string
    widgetId: string
}
interface BuilderComponentsObject {
    register(identifier: string, manifest: Builder.Manifest): void
    getCompAppData(componentType: string): AppData | undefined
}

export interface BuilderObject {
    components: BuilderComponentsObject
}

export interface OverrideOrDefaultData {
    type: string
    prop: string
    value: any
    metaData: any
    whereToWriteInDM: string
    path?: string[]
}

export const SYSTEM_CONTAINER_TYPE = 'wixSystemElements.InternalContainer'
